import React from "react";
import UseCaseOne from "../components/UseCaseOne";
import MarketPlaceLayout from "../components/Layout/MarketPlaceLayout";


function UseCasesPage() {
  return (
    <MarketPlaceLayout>
          <UseCaseOne />
    </MarketPlaceLayout>
  );
}

export default UseCasesPage;
